<section *ngIf="infoReport">
  <div class="card">
    <div class="card-header bg-body">
      <h2>View information report details</h2>
      <button type="button" *removeIfUnauthorizedIR="canEdit" (click)="editIR()" class="btn btn-active my-3"  tabindex="0" nessAutoFocus>Edit information report</button>
    </div>
    <div class="card-body">
      <error-status *ngIf="displayErrorStatus" [messageTemplate]="errorMessage"></error-status>
      <div class="card-title"><h3 class="h4">Basic tracking data</h3></div>
      <div class="row gy-2 gx-3 align-items-center m-2">
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">IR tracking #:</div>
        <div class="col-lg-9 col-md-8">{{ infoReport.IntelligenceTrackingNumber }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Field Division:</div>
        <div class="col-lg-9 col-md-8">{{ infoReport.CGICCode | CGICCodeToFD | async }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Title:</div>
        <div class="col-lg-9 col-md-8">{{ infoReport.Title }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Priority:</div>
        <div class="col-lg-9 col-md-8">{{ infoReport.ENESS_REF_IntelligenceReportPriorities?.Priority}}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Status:</div>
        <div class="col-lg-9 col-md-8">{{ infoReport.ENESS_REF_IntelligenceReportStatuses?.Status}}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Assigned Personnel:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Primary</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReport.ENESS_XREF_IRsAssignedCGICPersonnel.length == 0;else psnlrows">
                <tr>
                  <td colspan="2">No assigned personnel found.</td>
                </tr>
              </ng-container>
              <ng-template #psnlrows>
                <tr *ngFor="let psnl of infoReport.ENESS_XREF_IRsAssignedCGICPersonnel">
                  <th scope="row">{{psnl.ENESS_ApplicationUser.FirstName + ' ' + psnl.ENESS_ApplicationUser.LastName}}</th>
                  <th scope="row">{{psnl.ENESS_ApplicationUser.Email }}</th>
                  <td>{{psnl.IsPrimary | booleanTransform }}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Type(s):</div>
        <div class="col-lg-9 col-md-8">
          <ng-container *ngFor="let type of infoReport.ENESS_XREF_IRsTypes;let i=index">
            {{ type.ENESS_REF_IntelligenceReportTypes?.Type}}{{type.ENESS_REF_IntelligenceReportTypes?.Type == 'Other' ? ': '+infoReport.ENESS_XREF_IRsTypes[i].OtherText : ''}}{{i < (infoReport.ENESS_XREF_IRsTypes?.length - 1) ? ';' : ''}}
          </ng-container>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Purpose(s):</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Purpose</th>
                <th scope="col">Field division</th>
                <th scope="col">Group</th>
                <th scope="col">NFORCE case number</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReport.ENESS_XREF_IRsPurposes.length == 0;else purprows">
                <tr><td colspan="4">No purposes found.</td></tr>
              </ng-container>
              <ng-template #purprows>
                <tr *ngFor="let purpose of infoReport.ENESS_XREF_IRsPurposes">
                  <th scope="row">{{purpose.ENESS_REF_IntelligenceReportPurposes.Purpose}}</th>
                  <td>{{purpose.ENESS_XREF_IRsPurposesFieldDivisions?.ENESS_REF_FieldDivisions?.FieldDivisionName}}</td>
                  <td>{{purpose.ENESS_XREF_IRsPurposesFieldDivisions?.ENESS_REF_IntelligenceReportATFReferralGroups?.GroupName}}</td>
                  <td>{{purpose.ENESS_XREF_IRsPurposesFieldDivisions?.NFORCECaseNumber}}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-title"><h3 class="h4">Events, NIBIN leads, and targets</h3></div>
      <div class="row gy-2 gx-3 align-items-center m-2">
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Crime Gun ID(s):</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Crime Gun ID</th>
                <th scope="col">Primary</th>
                <th scope="col"># of Linked Shootings</th>
                <th scope="col">Triage Level; Date</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReportCrimeGunNumbers.length == 0;else cgrows">
                <tr>
                  <td colspan="3">No assigned crime guns found.</td>
                </tr>
              </ng-container>
              <ng-template #cgrows>
                <tr *ngFor="let cgn of infoReportCrimeGunNumbers">
                  <th scope="row">
                    <ng-container *ngIf="!!cgn.CrimeGunNumberID; else nocglink">
                      <a (click)="openRelatedCrimeGun($event, cgn.CrimeGunNumberID)">{{cgn.CrimeGunNumber}}</a>
                    </ng-container>
                    <ng-template #nocglink>
                      <span [pTooltip]="cgn.IsOutsideAgency ? 'Outside Agency CGID' : 'CGID was deleted'">{{ cgn.CrimeGunNumber }}</span>
                    </ng-template>
                  </th>
                  <td>{{cgn.IsPrimary | booleanTransform }}</td>
                  <td>{{ cgn.NumberOfLinkedShootings }}</td>
                  <td>{{ !!cgn.MostRecentTriageLevel ? cgn.MostRecentTriageLevel + ';' : '' }} {{cgn.MostRecentTriageDate.toString() | localToUtc:'MM/dd/yyyy'}}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">RMS Event(s):</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">Agency</th>
                <th scope="col">LE Case #</th>
                <th scope="col">LE Partner</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReportLECaseNumbers.length == 0;else lcnrows">
                <tr>
                  <td colspan="4">No LE case #s found.</td>
                </tr>
              </ng-container>
              <ng-template #lcnrows>
                <tr *ngFor="let lcn of infoReportLECaseNumbers">
                  <th scope="row">{{lcn.StateAbbreviation}}</th>
                  <td>{{lcn.AgencyName}}</td>
                  <td>{{lcn.LECaseNumber}}</td>
                  <td>{{lcn.LEPartners}}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">People/Target(s):</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">FBI #</th>
                <th scope="col">State ID</th>
                <th scope="col">Last Name</th>
                <th scope="col">First Name</th>
                <th scope="col">Birth Date</th>
                <th scope="col">SSN</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReport.ENESS_XREF_IRsPeopleTargets.length == 0;else irtgtrows">
                <tr>
                  <td colspan="6">No people/targets found.</td>
                </tr>
              </ng-container>
              <ng-template #irtgtrows>
                <tr *ngFor="let pt of infoReport.ENESS_XREF_IRsPeopleTargets">
                  <th scope="row">
                    <div *ngFor="let fbiNum of pt.ENESS_Person?.ENESS_XREF_PeopleFBIFileNumbers">
                      {{fbiNum.FBIFileNumber}}
                    </div>
                  </th>
                  <td>
                    <div *ngFor="let stateId of pt.ENESS_Person?.ENESS_XREF_PeopleStateIDNumbers">
                      {{ stateId.ENESS_REF_State?.StateAbbreviation.concat(':')}} {{ stateId.StateIDNumbers}}
                    </div>
                  </td>
                  <td>{{pt.ENESS_Person?.LastName}}</td>
                  <td>{{pt.ENESS_Person?.FirstName}}</td>
                  <td>{{pt.ENESS_Person?.DateOfBirth | date:"MM/dd/yyyy"}}</td>
                  <td>{{pt.ENESS_Person?.SSN | ssnFormat}}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-title"><h3 class="h4">Summary and notes</h3></div>
      <div class="row gy-2 gx-3 align-items-center m-2">
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Summary:</div>
        <div class="col-lg-9 col-md-8">
          {{infoReport.Summary}}
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Notes:</div>
        <div class="col-lg-9 col-md-8">
          {{infoReport.Notes}}
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Attachments:</div>
        <div class="col-lg-9 col-md-8  table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Filename</th>
                <th scope="col" class="text-nowrap">Created by</th>
                <th scope="col" class="text-nowrap">Upload date</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReport.ENESS_XREF_IRsAttachments.length == 0;else attrows">
                <tr>
                  <td colspan="3">No uploaded attachments found.</td>
                </tr>
              </ng-container>
              <ng-template #attrows>
                <tr *ngFor="let att of infoReport.ENESS_XREF_IRsAttachments">
                  <th scope="row"><a tabindex="0" class="download-link" title="Download attachment file" (click)="onClickDownload(att.ENESS_IntelligenceReportAttachments)">{{att.ENESS_IntelligenceReportAttachments?.FileName}}</a></th>
                  <td>{{att.ENESS_IntelligenceReportAttachments?.CreatedBy}}</td>
                  <td>{{att.ENESS_IntelligenceReportAttachments?.CreatedOn | date:'MM/dd/yyyy'}}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Date(s) sent:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col" class="w-25">Date sent</th>
                <th scope="col">Recipients</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="infoReport.ENESS_XREF_IRsDatesSent.length == 0;else sentrows">
                <tr>
                  <td colspan="2">No dates sent found.</td>
                </tr>
              </ng-container>
              <ng-template #sentrows>
                <tr *ngFor="let ds of infoReport.ENESS_XREF_IRsDatesSent">
                  <th scope="row" class="w-25">{{ds.DateSent | date:'MM/dd/yyyy'}}</th>
                  <td>{{ds.Recipients}}</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

